import { useDispatch } from "react-redux";

import { DeleteOutline, Download, PreviewOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import { isFileNamePdf } from "core/file_utils";
import { deleteSomOfferJust } from "slices/som/services/deleteSomOfferJust";
import { downloadSomOfferJust } from "slices/som/services/downloadSomOfferJust";
import { previewSomOfferJust } from "slices/som/services/previewSomOfferJust";

import styles from "./JustificationsList.module.css";

export const JustificationsListItem = ({ justId, fileName }) => {
	const dispatch = useDispatch();

	return (
		<div className={styles.container}>
			<span className={styles.title}>{fileName}</span>
			<div className={styles.actions}>
				<IconButton size="small" disabled={!isFileNamePdf({ fileName })} onClick={() => dispatch(previewSomOfferJust({ justId, fileName }))}>
					<PreviewOutlined sx={{ fontSize: "16px" }} />
				</IconButton>
				<IconButton size="small" onClick={() => dispatch(downloadSomOfferJust({ justId, fileName }))}>
					<Download sx={{ fontSize: "16px" }} />
				</IconButton>
				<IconButton size="small" onClick={() => dispatch(deleteSomOfferJust({ justId }))}>
					<DeleteOutline sx={{ fontSize: "16px" }} />
				</IconButton>
			</div>
		</div>
	);
};
